import { map, Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { Tag } from '../models/tag.model';
import { ApolloService } from './apollo.service';

@Injectable({
  providedIn: 'root',
})
export class TagService {
  private return = `
    {

    }
  `;
  private apolloService = inject(ApolloService);

  getTags(): Observable<Tag[]> {
    return this.apolloService.query(`{tags${this.return}}`, 'tags');
  }

  getTag(tagId: string): Observable<Tag> {
    return this.apolloService.query(
      `{tag(id: "${tagId}")${this.return}}`,
      'tag'
    );
  }

  createTag(tag: Tag): Observable<Tag> {
    return this.apolloService.mutate(
      `CreateTag($tag: CreateTagInput!) {
            createTag(createTagInput: $tag)${this.return}
          }`,
      'createTag',
      { tag }
    );
  }

  updateTag(tag: Tag): Observable<Tag> {
    return this.apolloService.mutate(
      `UpdateTag($tag: UpdateTagInput!) {
            updateTag(updateTagInput: $tag)${this.return}
          }`,
      'updateTag',
      { tag }
    );
  }

  deleteTag(tagId: string): Observable<boolean> {
    return this.apolloService
      .mutate<number>(
        `RemoveTag($tagId: string!) {
                        removeTag(id: $tagId)
                    }`,
        'removeTag',
        { tagId }
      )
      .pipe(map((x) => x > 0));
  }
}
